import { render, staticRenderFns } from "./VoiceInviteBanner.vue?vue&type=template&id=53e9894a&scoped=true"
import script from "./VoiceInviteBanner.vue?vue&type=script&lang=js"
export * from "./VoiceInviteBanner.vue?vue&type=script&lang=js"
import style0 from "./VoiceInviteBanner.vue?vue&type=style&index=0&id=53e9894a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e9894a",
  null
  
)

export default component.exports